import { useAuth0 } from "@auth0/auth0-react";
import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  Radio,
  RadioGroup,
  Tooltip,
  Typography,
} from "@mui/material";
import Divider from "@mui/material/Divider";
import { useRadioGroup } from "@mui/material/RadioGroup";
import { styled } from "@mui/material/styles";
import user from "assets/icons/user.jpg";
import { LabelField } from "components/LabelField";
import { MyCheckbox } from "components/MyCheckbox";
import Selection from "components/Selection/Selection";
import PastoralService from "Lib/API/PastoralApi/index";
import React, { useEffect, useState } from "react";
import { toastr } from "react-redux-toastr";
import defaultUser from "../../../../assets/icons/defaultUserSetting.svg";
import { InputField } from "../../../../components/InputField";
import UserService from "../../../../Lib/API/users";
import { uploadFile } from "../../../Auth/Presigned";
import VacationBox from "../addUserDrawer/VacationBox";
import ResetMobilePassword from "../ResetMobilePassword/ResetMobilePassword";
import "./UpdateUserDrawer.scss";
import { fontConfig } from "theme/fontConfig";
import InfoTooltip from "components/InfoTooltip";

const StyledFormControlLabel = styled((props) => (
  <FormControlLabel {...props} />
))(({ theme, checked }) => ({
  ".MuiFormControlLabel-label": checked && {
    color: theme.palette.primary.main,
  },
}));

function MyFormControlLabel(props) {
  const radioGroup = useRadioGroup();

  let checked = false;

  if (radioGroup) {
    checked = radioGroup.value === props.value;
  }

  return <StyledFormControlLabel checked={checked} {...props} />;
}

// for test
const selectUserTest = [
  <div className="d-flex alien-items-center">
    <img
      src={user}
      alt=""
      style={{
        width: "31px",
        height: "31px",
        borderRadius: "50%",
      }}
    />{" "}
    <span>Amran test</span>
  </div>,
  <div className="d-flex alien-items-center">
    <img
      src={user}
      alt=""
      style={{
        width: "31px",
        height: "31px",
        borderRadius: "50%",
      }}
    />{" "}
    <span>Amran test</span>
  </div>,
  <div className="d-flex alien-items-center">
    <img
      src={user}
      alt=""
      style={{
        width: "31px",
        height: "31px",
        borderRadius: "50%",
      }}
    />{" "}
    <span>Amran test</span>
  </div>,
  <div className="d-flex alien-items-center">
    <img
      src={user}
      alt=""
      style={{
        width: "31px",
        height: "31px",
        borderRadius: "50%",
      }}
    />{" "}
    <span>Amran test</span>
  </div>,
];

const UpdateUserDrawer = ({
  isUpdateUserDrawerOpen,
  closeModal,
  handleClose,
  setOpenShabbat,
  openShabbat,
  setOpenVacation,
  openVacation,
  updateUserRow,
  triggerUploadImg,
  profileImage,
  setRefresh,
  refresh,
  setIsDrawerOpen,
  setTriggerUploadImg,
  pictures,
  setProfileImage,
  openMobileResetPassword
}) => {
  const [usersData, setUsersData] = useState([]);
  const [eventUserLoading, setEventUserLoading] = useState(false);
  const [userImage, setUserImage] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [role, setRole] = useState("");
  const [postoral, setPostoral] = useState(false);
  const [loading, setLoading] = useState(false);
  const [updateUserLoading, setUpdateUesrLoading] = useState(false);
  const [listModules, setListModules] = useState([]);
  const { getAccessTokenSilently } = useAuth0();
  const [newClergy, setNewClergy] = useState(false);
  const [selectedModule, setSelectedModule] = useState({
    pastoral: {},
    finance: {},
    education: {},
    members: {},
    report: {},
    settings: {},
    "user management": {},
  });
  const subModuleActiveElement = {
    vacation: {
      active: true,
      component: <VacationBox
        usersData={usersData}
        eventUserLoading={eventUserLoading}
        setSelectedModule={setSelectedModule}
        selectedModule={selectedModule}
      />
    }
  }
  useEffect(() => {
    setUserImage(updateUserRow?.profile_img);
    setFirstName(updateUserRow.name?.split(" ")[0]);
    setLastName(
      updateUserRow?.name?.slice(updateUserRow?.name?.split(" ")[0].length + 1)
    );
    setRole(updateUserRow.role);

  }, []);

  useEffect(() => {
    if (!usersData?.length && eventUserLoading) return;
    const formattedModules = updateUserRow?.authorizedModules?.reduce(
      (acc, item) => {
        acc[item.moduleName] = {
          ...item,
          active: item.active,
          description: usersData?.length ? usersData?.find((user) => user.value == item.description) : null,
          subModule: item.subModule?.reduce(
            (subAcc, subItem) => {
              subAcc[subItem.subModuleName] = {
                ...subItem,
                active: subItem.active,
                description: usersData?.length ? usersData?.find((user) => user.value == subItem.description) : null,
              };
              return subAcc;
            },
            {}
          ),
        };
        return acc;
      },
      {}
    );

    setSelectedModule(formattedModules);
  }, [usersData, updateUserRow]);

  const getUsersHandler = async () => {
    setEventUserLoading(true);
    const token = await getAccessTokenSilently();
    PastoralService.getEventUsers({ token, page: 1 })
      .then((res) => {
        if (res) {
          const formattedUsers = res?.users.map((item) => ({
            label: `${item?.type} ${item?.fullName ? "- " + item?.fullName : ""}`,
            value: item?.id
          }));
          setUsersData(formattedUsers);
        }
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setEventUserLoading(false);
      });
  };

  useEffect(() => {
    getUsersHandler();
    getAuthorizedModules();
  }, []);


  const createNewClergyHandler = async (data) => {
    const token = await getAccessTokenSilently();
    const payload = {
      fname: data?.first_name,
      lname: data?.last_name,
      email: data?.email,
      role: data?.role,
      easy_contact_id: data?.easy_contact_id,
      auth0_id: data?.auth0_id,
    }
    await PastoralService.createNewClergy({ token, data: payload })
      .then((response) => {
        handleAfterCreate(true, payload?.easy_contact_id);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setUpdateUesrLoading(false);
      });
  }
  const updateClergyHandler = async (data) => {
    const token = await getAccessTokenSilently();
    const payload = {
      id: data?.id?.toString(),
      contactId: data?.contactId,
    }
    await PastoralService.updateClergy({ token, data: payload })
      .then((response) => {
        handleAfterCreate();
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong");
      })
      .finally(() => {
        setUpdateUesrLoading(false);
      });
  }

  const handleAfterCreate = (showResetPassword, contactId) => {
    setRefresh(!refresh);
    setUpdateUesrLoading(false);
    if (showResetPassword) {
      openMobileResetPassword("add", contactId);
    } else {
      handleClose();
      setProfileImage('');
    }
    return toastr.success('User Updated Successfully');
  }


  const getAuthorizedModules = async () => {
    setLoading(true);
    const token = await getAccessTokenSilently();
    await UserService.authorizedModules(token).then((res) => {
      setListModules(res.result);
      // setModule(res.result.forEach((item) => item.available === true ? {...module, module[item.moduleName]: item.available}: null))
      setLoading(false);
    });
  };

  const moduleFiltered = [];

  const listModulesValidate = listModules.map((item) => ({
    moduleName: item?.moduleName,
    available: item?.available,
  }));


  for (let { moduleName, available } of listModulesValidate) {
    const hasSubModule = Object.keys(selectedModule[moduleName]?.subModule || {})?.length > 0;

    if (available) {
      moduleFiltered.push({
        moduleName: moduleName,
        active: selectedModule[moduleName]?.active,
        ...(selectedModule[moduleName]?.description?.value ?
          {
            description: selectedModule[moduleName]?.description?.value?.toString(),
          } : {}
        ),
        ...(hasSubModule ? {
          subModule: Object.keys(selectedModule[moduleName]?.subModule)?.map((subKey) => ({
            subModuleName: subKey,
            active: selectedModule[moduleName]?.subModule?.[subKey]?.active,
            ...(selectedModule[moduleName]?.subModule?.[subKey]?.description?.value ? {
              description: selectedModule[moduleName]?.subModule?.[subKey]?.description?.value?.toString(),
            } : {}
            ),
          }))
        } : {})
      });
    }
  }


  // user validation
  const validateSubmit = () => {
    if (!firstName || !lastName || !role) {
      return toastr.info("Please fill all user fields");
    }
    updateUserApi();
  };

  const updateUserApi = async (e) => {
    setUpdateUesrLoading(true);
    const token = await getAccessTokenSilently();
    const newUrl = (await pictures?.length)
      ? await uploadFile(pictures[0], pictures[0], token)
      : "";
    const payload = {
      userId: updateUserRow._id,
      contactId: updateUserRow.contactId,
      first_name: firstName,
      last_name: lastName,
      role,
      profile_img: newUrl.fileName ? newUrl.fileName : undefined,
      authorizedModules: moduleFiltered.filter(
        (item) => item.active !== undefined
      ),
    }
    await UserService.updateUser(token, payload)
      .then((res) => {
        const clergyType = selectedModule?.pastoral?.description;
        if (newClergy) {
          return createNewClergyHandler({
            ...payload,
            email: updateUserRow.email,
            easy_contact_id: res?.updateAdminModels?.permissions?.linked_contact,
            auth0_id: res?.updateAdminModels?.auth0_id,
          });
        } else if (clergyType?.value) {
          return updateClergyHandler({
            id: clergyType?.value,
            contactId: res?.updateAdminModels?.permissions?.linked_contact,
          });
        }
        handleAfterCreate();
      })
      .catch((err) => {
        setUpdateUesrLoading(false);
        return toastr.error(err?.data?.message ?? "Error Updating User");
      });
    setIsDrawerOpen(false);
  };

  return (
    <Box
      width="608px"
      textAlign="center"
      role="presentation"
      sx={{ padding: "28px 45px", fontFamily: fontConfig.SettingsUpdateUserDrawerTextFont.family }}
    >
      <div
        className="text-left"
        style={{ fontSize: "16px", cursor: "pointer", fontFamily: fontConfig.SettingsUpdateUserDrawerTextFont.family }}
        onClick={() => closeModal()}
      >
        x
      </div>

      <div className="update__user__header mt-3">
        <p className="edit_user_text">Edit User</p>
        <div className="user__header__action">
          <button
            className="cancel_user_btn"
            onClick={() => closeModal()}
          >
            Cancel
          </button>
          <button
            className="save_user_btn btn btn-primary"
            onClick={() => validateSubmit()}
            disabled={updateUserLoading}
          >
            <span className="user_btn_text">Save</span>
            {updateUserLoading && (
              <span className="ml-3 spinner spinner-white"></span>
            )}
          </button>
        </div>
      </div>
      <div
        className="user__photo mt-5"
        onClick={() => setTriggerUploadImg(true)}
      >
        <img
          src={
            !triggerUploadImg && userImage
              ? userImage
              : profileImage
                ? profileImage
                : defaultUser
          }
          alt="user"
          style={{ width: "92px", height: "92px", borderRadius: "50%" }}
        />
        <p
          style={{
            color: "#2555EF",
            fontSize: "16px",
            fontWeight: "600",
            marginTop: "10px",
            fontFamily: fontConfig.SettingsUpdateUserDrawerTextFont.family,
          }}
        >
          Update photo
        </p>
      </div>
      <div className="first__field d-flex align-items-center justify-content-between">
        <InputField
          mandatory
          type="text"
          {...{
            title: "First Name",
            placeholder: "first name",
          }}
          value={firstName}
          handleChange={(e) => {
            setFirstName(e.target.value);
          }}
        />
        <InputField
          mandatory
          type="text"
          title="Last Name"
          placeholder="last name"
          value={lastName}
          handleChange={(e) => setLastName(e.target.value)}
        />
      </div>
      <div className="second__field">
        <InputField
          mandatory
          type="text"
          title="Role"
          placeholder="role"
          value={role}
          handleChange={(e) => setRole(e.target.value)}
        />
      </div>
      <Divider
        sx={{ marginTop: "35px", marginBottom: "67px", color: "#002E5C" }}
      />
      <Typography
        variant="subtitle1"
        className="mt-3 mb-3 ml-2 d-flex align-items-center"
        sx={{ color: "#9FA0A2", gap: "6px" }}
        textAlign="left"
      >
        PERMISSIONS
        <InfoTooltip text="For each module, Admin gives this staff user full access and Disable gives none. There is no partial or view-only access." placement="bottom" />
      </Typography>
      <div className="input_radio_field">
        {listModules.length === 0 ? (
          loading ? (
            <p>loading...</p>
          ) : (
            <p>No Modules Available</p>
          )
        ) : (
          listModules.map(({ _id, moduleName, subModule, available }, ndx) => {
            const isLast = listModules.length - 1 === ndx;
            return (
              <div key={_id}>
                <div className="first_field">
                  <div
                    className={`role__field ${!available ? "disable__module" : ""
                      }`}
                  >
                    {moduleName}
                  </div>
                  <FormControl>
                    <RadioGroup
                      row
                      aria-labelledby="Members"
                      name={moduleName}
                      value={selectedModule[moduleName]?.active || false}
                      onChange={(e) => {
                        setSelectedModule((prev) => ({
                          ...prev,
                          [moduleName]: {
                            ...prev[moduleName],
                            active: e.target.value === 'true' ? true : false,
                          },

                        }))
                      }
                      }
                      defaultValue={selectedModule[moduleName]?.active || false}
                    >
                      <MyFormControlLabel
                        value={true}
                        control={<Radio size="small" disabled={!available} />}
                        label="Admin"
                      />
                      <MyFormControlLabel
                        value={false}
                        control={<Radio size="small" disabled={!available} />}
                        label="Disable"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>
                {(subModule?.length > 0 && selectedModule[moduleName]?.active) && (
                  <div className="shabbat">
                    <div
                      className="form-group mt-5"
                      style={{
                        textAlign: 'left',
                      }}
                    >
                      <div className='d-flex justify-content-between align-items-center'>
                        <LabelField
                          title={"Clergy type"}
                          style={{
                            fontSize: "12px",
                          }}
                          mandatory={false}
                        />
                        {updateUserRow?.email && (
                          <MyCheckbox
                            title="create new"
                            handlechange={(e) => {
                              const { checked } = e.target;
                              setNewClergy(checked);
                              setSelectedModule((prev) => ({
                                ...prev,
                                [moduleName]: {
                                  ...prev[moduleName],
                                  description: "",
                                },
                              }));
                            }}
                            checked={newClergy}
                            style={{

                            }}
                          />
                        )}
                      </div>
                      {newClergy ? (
                        <InputField
                          type="text"
                          value={role}
                          disabled={true}
                          title="none"
                          placeholder="Please enter a role"
                        />
                      ) :
                        (
                          <Selection
                            name="clergyType"
                            mandatory={false}
                            placeholder="Select a clergy"
                            options={usersData}
                            isLoading={eventUserLoading}
                            style={"secondary"}
                            onChange={(value) => {
                              setSelectedModule((prev) => ({
                                ...prev,
                                [moduleName]: {
                                  ...prev[moduleName],
                                  description: value,
                                },
                              }));
                            }}
                            value={selectedModule[moduleName]?.description}
                            isClearable={true}
                            isDisabled={newClergy}
                          />
                        )}
                      {/* <Selection
                        name="clergyType"
                        mandatory={false}
                        placeholder="Select a clergy"
                        options={usersData}
                        isLoading={eventUserLoading}
                        style={"secondary"}
                        onChange={(value) => {
                          setSelectedModule((prev) => ({
                            ...prev,
                            [moduleName]: {
                              ...prev[moduleName],
                              description: value,
                            },
                          }));
                        }}
                        value={selectedModule[moduleName]?.description}
                        isClearable={true}
                        isDisabled={newClergy}
                      /> */}
                    </div>
                    {subModule?.map(({ _id, subModuleName, active }, subIndex) => (
                      <div className='mt-5' key={_id}>
                        <div className="first_field_shabbat">
                          <div className="shabbat__text">{subModuleName}</div>
                          <FormControl>
                            <RadioGroup
                              row
                              aria-labelledby={subModuleName}
                              name={subModuleName}
                              value={selectedModule[moduleName]?.subModule?.[subModuleName]?.active ? true : false}
                              onChange={(e) => {
                                setSelectedModule((prev) => ({
                                  ...prev,
                                  [moduleName]: {
                                    ...prev[moduleName],
                                    subModule: {
                                      ...prev[moduleName]?.subModule,
                                      [subModuleName]: {
                                        ...prev[moduleName]?.subModule?.[subModuleName],
                                        active: e.target.value === 'true',
                                      },
                                    }
                                  },
                                }));
                              }}
                              defaultValue={selectedModule[moduleName]?.subModule?.[subModuleName]?.active || false}
                            >
                              <MyFormControlLabel
                                value={true}
                                control={<Radio size="small" />}
                                label="Yes"
                              />
                              <MyFormControlLabel
                                value={false}
                                control={<Radio size="small" />}
                                label="No"
                              />
                            </RadioGroup>
                          </FormControl>
                        </div>
                        {subIndex !== subModule.length - 1 && (
                          <Divider
                            sx={{
                              color: '#3F4255',
                              marginTop: '12px',
                              marginBottom: '12px',
                            }}
                          />
                        )}
                        {(selectedModule[moduleName]?.subModule?.[subModuleName]?.active && subModuleActiveElement?.[subModuleName]?.active) ? subModuleActiveElement?.[subModuleName]?.component : null}
                      </div>
                    ))}
                    {(moduleName === "pastoral" && selectedModule[moduleName]?.description?.value) && (
                      <ResetMobilePassword
                        openMobileResetPassword={() => {
                          openMobileResetPassword(updateUserRow);
                        }}
                      />
                    )}
                  </div>
                )}
                {!isLast && (
                  <Divider
                    sx={{
                      color: "#3F4255",
                      marginTop: "12px",
                      marginBottom: "12px",
                    }}
                  />
                )}
              </div>
            );
          })
        )}

      </div>
    </Box>
  );
};

export default UpdateUserDrawer;
